import { useEffect, useState } from 'react';
import { apiGet } from './ApiRequest';

export const useApiGet = <T>(url: string) => {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await apiGet<T>(url);
      setLoading(false);
      setData(response.data);
    } catch (err: any) {
      setLoading(false);
      setError(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [url]);

  return { data, loading, error };
};
